import React, { useEffect, useState } from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import TimeLineSettings from "../WidgetsSettings/TimeLine/TimeLineSettingsModal";
import IntlMessages from "@util/IntlMessages";
import { getList } from "services/api/Api";

import TimeLine from "../../TimeLine/TimeLine";
import { isActivePublicUser } from "../../../util/Scripts";

const TimeLineWidget = ({ value, role }) => {
   const [listData, setListData] = useState([]);
   const [columnsList, setColumnsList] = useState([]);

   useEffect(() => {
      const count = value.itemsPerWidget != null ? value.itemsPerWidget : 10;
      if (value.listId != null) {
         getList(value.listId, 1, count).then((res) => {
            const responseData = isActivePublicUser() ? res.data.getPublicList : res.data.default;
            setListData(responseData.data);
            setColumnsList(responseData.columns);
         });
      } else setListData(null);
   }, [value.listId, value.itemsPerWidget]);
   return (
      <>
         <Widget
            styleName="gx-m-0"
            bgColor={value.backgroundColourHex}
            role={role}
            extra={
               (role === "OWNER" || role === "MODERATOR") && (
                  <SettingsModal
                     widgetId={value.id}
                     widgetName={value.name}
                     icon="setting"
                     deleteIcon="true"
                     children={<TimeLineSettings value={value} columns={columnsList} />}
                  />
               )
            }
         >
            {value.listId != null ? (
               <TimeLine value={value} listData={listData} />
            ) : (
               <h6>
                  <IntlMessages id="timeline.selectListIdAndAttributes" />
               </h6>
            )}
         </Widget>
      </>
   );
};

export default TimeLineWidget;
